import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const { actions, reducer } = createSlice({
  name: 'brandsFilter',
  initialState: ['all', null],
  reducers: {
    setBrandsFilter: (state, action: PayloadAction<string[]>) => action.payload,
  },
});

const { setBrandsFilter } = actions;

export { setBrandsFilter, reducer as brandFilterReducer };
